import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="grain-overlay relative overflow-hidden py-28 lg:py-36">
      <img
        src="/images/alwasl-dome-show.jpeg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover opacity-30"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/70 to-[#050505]" aria-hidden="true" />
      <div className="relative z-10 mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.3em] text-electric">
            <span className="h-px w-12 bg-electric" aria-hidden="true" />
            Let's build your show
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display text-5xl font-semibold uppercase leading-[0.98] tracking-tight text-neutral-100 sm:text-6xl lg:text-7xl" data-testid="final-cta-headline">
            Have a show <span className="text-glow-amber text-electric">in mind?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-neutral-400 sm:text-lg">
            Whether it's a concert, festival, corporate production, or live event — let's talk about the
            audio requirements.
          </p>
        </Reveal>
        <Reveal delay={0.3}>
          <a
            href="#contact"
            data-testid="final-cta-button"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-electric px-9 py-4 text-xs font-extrabold uppercase tracking-[0.15em] text-[#050505] transition-[transform,background-color] duration-300 hover:-translate-y-1 hover:bg-[#ffa733]"
          >
            Start a Conversation <ArrowUpRight size={16} aria-hidden="true" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
